import { getApi, getApiErrorAdmin, getApiErrorMypage } from "../utils/common";

export const getCodeMasterList = async (code, isMypage = false) => {
  const urlPath = "/api/common/codemasterlist/?";
  const searchParams = new URLSearchParams(code);
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    // 呼び出し元のページでリダイレクト先を分岐
    if (isMypage) {
      getApiErrorMypage(e, urlPath, searchParams);
    } else {
      getApiErrorAdmin(e, urlPath, searchParams);
    }
  }
};
